import { Delete, Edit, VisibilityOutlined } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Base64Image } from '../../../../utils/settings';
import { getPancardImageAction } from '../APIs/action';
import IconReusable from '../../../../components/IconReusable';

const DetailCard = ({
  details,
  isDeletable,
  handleDelete = null,
  isNominee = false,
  beneficiary_id = null,
  selectedCompanyEntity,
  benefit_card = null,
}) => {
  const [openImage, setOpenImage] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const [loader, setLoader] = React.useState(false);
  const [panImageError, setPanImageError] = React.useState('');

  const handleViewImage = (id, selectedCompanyEntity, panImageError) => {
    getPancardImage(id, selectedCompanyEntity);
    !panImageError && setOpenImage(true);
  };
  const handleClose = () => {
    setOpenImage(false);
    setSelectedImage('');
  };
  const DetailFieldWithImage = ({ openImage, selectedImage, handleClose }) => (
    <Dialog
      open={openImage}
      onClose={handleClose}
      maxWidth='sm'
    >
      <DialogContent sx={{ textAlign: 'center' }}>
        {loader ? (
          <CircularProgress sx={{ color: '#FFA525', fontSize: '30px' }} />
        ) : (
          selectedImage && (
            <Base64Image
              base64String={selectedImage}
              style={{ width: '300px', marginBottom: '10px' }}
            />
          )
        )}
      </DialogContent>
    </Dialog>
  );
  const DetailField = ({ label, value, handleViewImage, panImageError, benefit_card }) => (
    <Box
      display='flex'
      justifyContent='space-between'
      sx={{ pb: 1 }}
    >
      <Typography
        variant='labelD'
        sx={{ color: '#666666' }}
      >
        {label}
      </Typography>
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
        >
          <Typography
            variant='p1'
            sx={{ textAlign: 'right', color: '#333333' }}
          >
            {value}
          </Typography>
          {label === 'PAN' && benefit_card?.value !== 'Golden Age Plan' && (
            <Box sx={{}}>
              <VisibilityOutlined
                onClick={() =>
                  handleViewImage(
                    details?.id,
                    selectedCompanyEntity,
                    panImageError,
                  )
                }
                fontSize='small'
                sx={{ color: '#FFA525', cursor: 'pointer' }}
              />
            </Box>
          )}
        </Box>
        {label === 'PAN' && panImageError && (
          <Typography sx={{ color: '#CC0000', fontSize: '14px' }}>
            {panImageError}
          </Typography>
        )}
      </Box>
    </Box>
  );
  const getPancardImage = async (beneficiary_id, selectedCompanyEntity) => {
    setLoader(true);
    const { error, data } = await getPancardImageAction(
      beneficiary_id,
      selectedCompanyEntity,
    );
    setLoader(false);
    if (!error) {
      setSelectedImage(data.pancard_image);
    } else {
      setPanImageError('No Image Found');
    }
  };
  return (
    <>
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 0.5,
          }}
        >
          <Box>
            <Typography variant='h2'>{details?.header_title}</Typography>
          </Box>
          <Box>
            {handleDelete && isDeletable && (
              <Tooltip title='Delete'>
                <IconButton
                  size='small'
                  sx={{ color: '#FFA525' }}
                  onClick={() => {
                    if (isNominee && beneficiary_id && details.id) {
                      handleDelete(beneficiary_id, true, details?.id);
                    } else if (details.id) {
                      handleDelete(details.id);
                    }
                  }}
                >
                  <IconReusable
                    name='Delete'
                    color='#995A00'
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </Box>
        <Box>
          {details.details &&
            details.details?.map((field, idx) => (
              <DetailField
                key={idx}
                label={field.display_name}
                value={field.display_value}
                file_url={field.file_url}
                handleViewImage={handleViewImage}
                panImageError={panImageError}
                benefit_card={benefit_card}
              />
            ))}
        </Box>
        {!panImageError && (
          <DetailFieldWithImage
            handleClose={handleClose}
            openImage={openImage}
            selectedImage={selectedImage}
          />
        )}
      </Box>
    </>
  );
};

export default DetailCard;
